import { URL_REGEX } from "../constants/validations";
import { sendFBQevent, sendPropertyEvent, initializateFBQ, initializateUA, initializateGA4, 
	initializateAW, sendAWEvent, } from "./analytics";
import { setKey, getKey, deleteKey } from "./localStorage";
export const isObjectEmpty = obj => Object.keys(obj).length === 0;

const isLocalDev = () => document.URL.includes("localhost");

export const isIOS = () => {
	var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
	var isAppleDevice = navigator.userAgent.includes('Macintosh');
	var isTouchScreen = navigator.maxTouchPoints >= 1;

	return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
};

const iosQuirkPresent = () => {
	var audio = new Audio();
	audio.volume = 0.5;
	return audio.volume === 1;
};

export const isDev = document.URL.includes("live-staging.vivet") || document.URL.includes("localhost") || document.URL.includes("ngrok");

const isLocalhost = document.URL.includes("localhost");

export const apiEndpoint =
	isDev
		? isLocalhost
			? process.env.REACT_APP_API_ENDPOINT
			: "https://central-staging.vivet.app/api"
		: "https://central.vivet.app/api";

export const domainEndpoint =
	isDev
		? "https://cubiqsupport.herokuapp.com" 
		: "https://app.livesupport.digital";		
		 

export const isLanding = (landingName) => {
	const url = document.URL.toLowerCase()
	const landingLC = landingName.toLowerCase()
	return url.split("/").includes(landingLC)
};

export const sendEvent = (googleEvent, facebookEvent) => {
	sendPropertyEvent(googleEvent);
	if (facebookEvent) sendFBQevent(facebookEvent);
};

export const sendAdwordsEvent = (awid, ctag)=> {
	if (awid && ctag) sendAWEvent(awid, ctag);
}

const between = (n, minor, mayor) => n > minor - 1 && n < mayor + 1 

export const phoneChecker = (countryCode, phone) => {
	const countryLimit = phonesCharacters[countryCode];
	const phoneSize = phone.length;
	return 	between(phoneSize, countryLimit - 1, countryLimit + 1);
};

const phonesCharacters = {
	"cl": 9,
	"pe": 9,
	"ar": 11,
	"mx": 11,
	"co": 10,
	"uy": 11,
	"py": 9,
	"br": 11,
	"ve": 10,
	"bo": 10,
	"us": 10,
	"es": 9,
	"it": 10,
};

export const gSender = (GA4id, UAid, FBQid, AWid) => {
	if (UAid) initializateUA(UAid);
	if (GA4id) initializateGA4(GA4id);
	if (FBQid) initializateFBQ(FBQid);
	if (AWid) initializateAW(AWid)
};


export const setWrapperTop = (cuestionsSize, restart) => {
	var top = 10;
	if (cuestionsSize > 1 && !restart) top = top - cuestionsSize * 3 + 3
	if (cuestionsSize >= 5) top = 1;
	document.documentElement.style.setProperty("--wrapper-top", `${top}vh`);
};

export const peerOptions =  { 
	port: "8443",
	path: '/peerjs', 
	host: "srv02.cubiq.digital", 
	secure: true 
};

export const videoResolution =  { 
	width: { 
		min: 640,
		max: 640 
	},
	height: { 
		min: 480,
		max: 480 
	},
};

export const getCameraPermissions = () => navigator.mediaDevices.getUserMedia({
	audio: true,
	video: videoResolution,
});

export const getScreenPermissions = () => navigator.mediaDevices.getDisplayMedia({
	audio: true,
	video: true,
});

export const getOnlyAudioPermissions = () => navigator.mediaDevices.getUserMedia({
	audio: true,
	video: false,
});

export const setForceReload = () => setKey("reload", true);

export const checkForReload = () => {
	const needReload = getKey("reload");
	if (needReload) window.location.href = window.location.href;
	deleteKey("reload");
};

export const inIframe = () => {
	try { return window.self !== window.top } 
	catch (e) { return true }
};

export const isMobileAgent = () => {
	let check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
  };
  
export const classByAgent = className => {
	const mobile = isMobileAgent() ;
	const iframe = inIframe()
	if (mobile) return `${className}Mobile`
	else if (iframe)  return `${className}Iframe`
	else return `${className}Desktop`
};

export const isMessageWithUrl = message => message
	.split(" ")
	.filter(word => word !== "")
	.filter(word => URL_REGEX(word))
	.length > 0;

export const extractMsgeUrl = message => message
	.split(" ")
	.filter(word => word !== "")
	.filter(word => URL_REGEX(word))[0];

	export const addFeedbacksAnalytics = id => {
		if (!isLocalDev()){
		  var faScript = document.createElement("SCRIPT");
		  faScript.defer = true;
		  faScript.src = `https://analytics.cubiq.digital/pixel/${id}`;
		  document.getElementsByTagName("head")[0].appendChild(faScript);
		};
	  };

	 export const namefile = (string)=> {
		const newName = string.split(".")
		const nameShortFile = newName[0].slice(0, 20)
	   if (newName.lenght < 20 ) return newName[0]
		else return `${nameShortFile}...` 
	  }
	
	 export  const fileExtension = (string) =>{
		const extension = string.split(".")
		const newExtension = extension [1]
		return newExtension
	  }

	  export const getBrowserInfo = () => {
		var ua= navigator.userAgent, tem, 
		M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		if(/trident/i.test(M[1])){
			tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
			return 'IE '+(tem[1] || '');
		}
		if(M[1]=== 'Chrome'){
			tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
			if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
		}
		M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
		if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
		return M.join(' ');
	};
	
	